<template>
  <div id="createReservation">
    <header-top showBack></header-top>
    <div class="header-title show-back">添加报备</div>
    <div class="main">
      <div class="main-title">报备信息</div>
      <div class="reservation-info">
        <el-form
          :model="reservationInfo"
          :rules="reservationRules"
          ref="reservationInfo"
          label-width="8rem"
          label-position="left"
        >
          <el-row>
            <el-col :span="10" v-if="!reservationInfo.estateName">
              <el-form-item
                prop="estateName"
                label="报备楼盘"
                class="auto-height"
              >
                <el-button type="text" @click="showEstate">选择楼盘</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-else>
              <el-form-item
                prop="estateName"
                label="报备楼盘"
                class="auto-height"
                v-if="estateInfo"
              >
                <el-button type="text" @click="showEstate">修改楼盘</el-button>
                <div class="estate-info">
                  <div class="estate-main">
                    <img
                      class="estate-cover"
                      v-if="!estateInfo.hasCover"
                      src="@/assets/image/estate-cover.jpg"
                      alt=""
                    />
                    <img
                      class="estate-cover"
                      v-if="estateInfo.hasCover"
                      :src="estateInfo.coverUrl"
                      alt=""
                    />
                    <div class="edtate-detail">
                      <div class="name">
                        {{ estateInfo.name
                        }}<span class="status">{{
                          estateInfo.saleStatus
                        }}</span>
                      </div>
                      <div class="address">
                        {{ estateInfo.city }}{{ estateInfo.district
                        }}{{ estateInfo.street ? "-" + estateInfo.street : ""
                        }}{{
                          estateInfo.business ? "-" + estateInfo.business : ""
                        }}
                      </div>
                      <div class="info">
                        报备号码: {{ reservationRule.numberType | nullValue }} |
                        报备有效时长 ：{{
                          reservationRule.protectedNumber | nullValue
                        }}{{ reservationRule.protectedUnit | nullValue }}
                        <!-- 报备号码: -- | 提前报备时长：-- | 报备有效时长 ：-- -->
                      </div>
                    </div>
                  </div>
                  <div class="estate-price">
                    {{ estateInfo.minPrice }} 元/㎡
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" v-if="!reservationInfo.customerName">
              <el-form-item prop="customerName" label="报备客户">
                <el-button type="text" @click="showCustomers"
                  >选择客户</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="20" v-else>
              <el-form-item
                prop="customers"
                label="报备客户"
                class="auto-height"
              >
                <div class="get-customer">
                  <el-button type="text" @click="showCustomers"
                    >修改客户</el-button
                  >
                  <div>
                    <el-input
                      class="customer-input"
                      v-model="reservationInfo.customerName"
                      disabled
                    ></el-input>
                    <div class="phone">
                      <span v-if="!isShowPhone" class="customer-phone">{{
                        reservationInfo.customerPhoneNumber
                      }}</span>
                      <span v-else class="customer-phone">{{
                        customerPhoneNumber
                      }}</span>
                      <span class="show-svg" @click="LookPhone">
                        <svg-icon icon-class="hidden" v-if="isShowPhone" />
                        <svg-icon icon-class="show" v-else />
                      </span>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="visitTime" label="到访时间">
                <el-date-picker
                  v-model="reservationInfo.visitTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="visitPersonNumber" label="到访人数">
                <el-select
                  v-model="reservationInfo.visitPersonNumber"
                  clearable
                  placeholder="请选择到访人数"
                >
                  <el-option
                    v-for="key in 10"
                    :key="key"
                    :label="key"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="flex form-flex">
            <div
              class="custom-form"
              v-for="(item, index) in fields"
              :key="index"
            >
              <el-form-item :label="item.name" :prop="item.name">
                <el-input
                  v-if="
                    item.fieldType == '文本输入' || item.fieldType == '数字输入'
                  "
                  :type="item.fieldType == '文本输入' ? 'text' : 'number'"
                  :placeholder="'请输入' + item.name"
                  v-model="reservationInfo[item.name]"
                  clearable
                >
                  <template
                    slot="append"
                    v-if="item.fieldType == '数字输入' && item.content"
                    >{{ item.content }}</template
                  >
                </el-input>
                <el-date-picker
                  v-else-if="item.fieldType == '日期选择'"
                  type="date"
                  :placeholder="'请选择' + item.name"
                  v-model="reservationInfo[item.name]"
                  @change="deteChange(reservationInfo[item.name], item.name)"
                >
                </el-date-picker>
                <el-select
                  v-model="reservationInfo[item.name]"
                  clearable
                  :placeholder="'请选择' + item.name"
                  v-else-if="item.fieldType == '下拉单选'"
                >
                  <el-option
                    v-for="item in item.content.split('；')"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="reservationInfo[item.name]"
                  clearable
                  :placeholder="'请选择' + item.name"
                  v-else-if="item.fieldType == '下拉多选'"
                  multiple
                  collapse-tags
                  class="multiple-select"
                >
                  <el-option
                    v-for="item in item.content.split('；')"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <div class="flex" v-else-if="item.fieldType == '上传附件'">
                  <el-upload
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-change="uploadFileChange"
                    :file-list="reservationInfo[item.name]"
                    :show-file-list="false"
                    :auto-upload="false"
                    multiple
                    accept=".jpg, .png, .jpeg"
                  >
                    <el-button
                      class="color-btn upload-btn"
                      @click="uploadFileType(item.name)"
                      >上传资料</el-button
                    >
                  </el-upload>
                  <div class="file-box">
                    <div v-if="reservationInfo[item.name].length == 1">
                      <div
                        v-for="(item, index) in reservationInfo[item.name]"
                        :key="index"
                        class="flex"
                      >
                        <div class="file-item flex">
                          <el-image
                            :ref="item.fileId"
                            :src="item.url"
                            :preview-src-list="[item.url]"
                          >
                          </el-image>
                          <span>{{ item.name }}</span>
                        </div>
                        <i
                          class="el-icon-close"
                          @click="delCustomFileItem(index)"
                        ></i>
                      </div>
                    </div>
                    <el-popover
                      placement="bottom"
                      trigger="hover"
                      :ref="item.name"
                    >
                      <div>
                        <div
                          v-for="(el, i) in reservationInfo[item.name]"
                          :key="i"
                          class="flex-between file-item pop-file"
                        >
                          <div class="flex">
                            <el-image
                              :ref="el.id"
                              v-if="el.fileType == 'image'"
                              :src="el.url"
                              :preview-src-list="[el.url]"
                            >
                            </el-image>
                            <img
                              src="@/assets/image/file-cover.png"
                              v-else
                              class="file-doc file-photo"
                            />
                            <span>{{ el.name }}</span>
                          </div>
                          <i
                            class="el-icon-close"
                            @click="delCustomFileItem(i)"
                          ></i>
                        </div>
                      </div>
                      <div
                        v-show="reservationInfo[item.name].length > 1"
                        class="file-itmes theme-color"
                        slot="reference"
                      >
                        <i class="el-icon-paperclip"></i>
                        <span>{{ reservationInfo[item.name].length }}</span
                        >个附件
                      </div>
                    </el-popover>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <el-row>
            <el-col :span="10">
              <el-form-item prop="business" label="备注" class="auto-height">
                <el-input
                  v-model="reservationInfo.more"
                  placeholder="请输入备注"
                  type="textarea"
                  maxlength="500"
                  show-word-limit
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="客户联系人信息" class="auto-height">
                <el-table :data="reservationInfo.contracts" border>
                  <el-table-column prop="name" label="姓名"> </el-table-column>
                  <el-table-column prop="gender" label="性别">
                  </el-table-column>
                  <el-table-column prop="phoneNumber" label="电话">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <div class="table-operation" v-if="!scope.row.isDefault">
                        <el-button
                          @click.native.prevent="editContract(scope.$index)"
                          type="text"
                          >编辑</el-button
                        >
                        <el-button
                          @click.native.prevent="delContract(scope.$index)"
                          type="text"
                          >删除</el-button
                        >
                      </div>
                      <div v-else>—</div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="add-contract">
                  <span @click="addContract" class="theme-color"
                    ><i class="el-icon-plus"></i>新增联系人信息</span
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="btn">
      <el-button @click="toReservations">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submitReservation"
        >提交</el-button
      >
    </div>
    <el-dialog
      title="选择客户"
      :before-close="customerClose"
      :visible.sync="isShowCustomer"
      class="dialog-estate dialog-auto dialog-basic"
    >
      <div class="estate-main">
        <div class="filter-heade">
          <el-input
            :placeholder="searchUserText"
            v-model="searchUserValue"
            class="input-with-select"
            clearable
          >
            <el-select
              v-model="searchUser"
              slot="prepend"
              placeholder="客户名称"
              @change="filterUserSelect"
            >
              <el-option
                v-for="item in searchUserOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getCustomers"
            ></el-button>
          </el-input>
        </div>
        <el-table
          :data="customers"
          border
          ref="tbCustomer"
          :header-cell-style="{ background: '#f7f7f7;' }"
          @selection-change="handleCustomersChange"
        >
          <el-table-column
            type="selection"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column label="客户名称" min-width="210">
            >
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="客户电话" min-width="210">
            >
            <template slot-scope="scope">
              {{ scope.row.phoneNumber }}
            </template>
          </el-table-column>
          <el-table-column label="经纪人名称" min-width="210" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.creatorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="经纪人电话" min-width="210" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.creatorPhoneNumber }}</span>
            </template>
          </el-table-column>

          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !estates.length">
              列表为空
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowCustomer = false">取消</el-button>
        <el-button type="primary" @click="submitCustomers" :disabled="userLock"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="选择楼盘"
      :before-close="estateClose"
      :visible.sync="isShowEstate"
      class="dialog-estate dialog-auto dialog-basic"
    >
      <div class="estate-main">
        <div class="filter-heade">
          <el-input
            :placeholder="searchText"
            v-model="searchValue"
            class="input-with-select"
            clearable
          >
            <el-select
              v-model="search"
              slot="prepend"
              placeholder="楼盘名称"
              @change="filterSelect"
            >
              <el-option
                v-for="item in searchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getPublicEstates"
            ></el-button>
          </el-input>
          <div class="filter-btn">
            <!-- <span class="filter-tit">项目区域</span> -->
            <span class="filter-tit">销售进度</span>
            <el-radio-group v-model="query.saleStatus">
              <el-radio
                v-for="item in sellStatus"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
        <el-table
          :data="estates"
          border
          ref="tb"
          :header-cell-style="{ background: '#f7f7f7;' }"
          @selection-change="handleEstatesChange"
        >
          <el-table-column
            type="selection"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column label="楼盘名称" min-width="210">
            >
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="销售状态" min-width="210">
            >
            <template slot-scope="scope">
              {{ scope.row.saleStatus }}
            </template>
          </el-table-column>
          <el-table-column label="行政区/街道" min-width="210" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.district }}-{{ scope.row.street }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用途" min-width="210" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.usingTypes.length">
                <span v-for="(item, index) in scope.row.usingTypes" :key="index"
                  >{{ item }}
                </span>
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column
            label="总价(万)"
            sortable
            min-width="130"
            align="center"
            prop="minTotalPrice"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.minTotalPrice }} -
                {{ scope.row.maxTotalPrice }}</span
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !estates.length">
              列表为空
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEstate = false">取消</el-button>
        <el-button type="primary" @click="submitEstates" :disabled="estatesLock"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="contractTitle"
      :before-close="contractClose"
      :visible.sync="isShowContract"
      class="dialog-top"
    >
      <el-form
        :model="contractForm"
        label-position="left"
        label-width="5rem"
        :rules="contractRules"
        ref="contractForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            placeholder="请输入联系人姓名"
            v-model="contractForm.name"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="contractForm.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话" prop="phoneNumber">
          <el-input
            placeholder="请输入联系人电话"
            v-model="contractForm.phoneNumber"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowContract = false">取消</el-button>
        <el-button type="primary" @click="submitContract">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { getPublicEstates, getPublicCounselors } from "@/http/api/estate";
import { createReservations, uploadMaterials } from "@/http/api/reservations";
import { getCustomers, getCustomerPhone } from "@/http/api/customer";
import { getReservationRule } from "@/http/api/marketing";
import { dateFormat } from "@/common/filters";
import { validatePhone } from "@/utils/validate";
import { deepCopy } from "@/utils/deepCopy";

export default {
  components: {
    headerTop,
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    return {
      contractTitle: "新增联系人",
      customFileType: "",
      contractIndex: "",
      isShowContract: false,
      isShowPhone: false,
      unfinished: true,
      userLock: true,
      estatesLock: true,
      customerPhoneNumber: "",
      reservationInfo: {
        estateId: "",
        estateName: "",
        visitPersonNumber: "",
        visitTime: "",
        more: "",
        customerId: "",
        customerName: "",
        customerPhoneNumber: "",
        organizationUnitId: this.$store.getters.user.organizationUnitId,
        contracts: [],
      },
      contractForm: {
        name: "",
        gender: "男",
        phoneNumber: "",
      },
      contractRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入联系人姓名",
          },
        ],
        gender: [
          {
            required: true,
            trigger: "change",
            message: "请选择联系人性别",
          },
        ],
        phoneNumber: [
          {
            required: true,
            trigger: "blur",
            validator: validatePhoneNumber,
          },
        ],
      },
      query: {
        maxResultCount: 20,
        saleStatus: "",
        isPutWeb: true,
        isPutChannel: true,
      },
      isShowEstate: false,
      isShowCustomer: false,
      loading: false,
      searchValue: "",
      search: "前缀搜索",
      searchText: "请输入楼盘名称/地址/项目负责人",

      searchUserValue: "",
      searchUser: "前缀搜索",
      searchUserText: "请输入客户名称/电话",
      estates: [],
      permissions: {},
      checkedEstate: {},
      estateInfo: {},
      customers: [],
      checkedCustomer: [],
      isLoading: false,
      reservationRule: {},
      reservationRules: {
        estateName: [
          {
            required: true,
            trigger: "change",
            message: "请选择楼盘",
          },
        ],
        customerName: [
          {
            required: true,
            trigger: "change",
            message: "请选择客户",
          },
        ],
        visitPersonNumber: [
          {
            required: true,
            trigger: "change",
            message: "请选择到访人数",
          },
        ],
        visitTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择到访时间",
          },
        ],
      },
      searchOptions: [
        {
          value: "name",
          label: "楼盘名称",
        },
        {
          value: "realAddress",
          label: "楼盘地址",
        },
        {
          value: "userName",
          label: "项目负责人",
        },
        {
          value: "",
          label: "全文搜索",
        },
      ],
      searchUserOptions: [
        {
          value: "name",
          label: "前缀搜索",
        },
        {
          value: "phoneNumber",
          label: "客户电话",
        },

        {
          value: "",
          label: "全文搜索",
        },
      ],
      sellStatus: [
        {
          label: "不限",
          value: "",
          isSelected: true,
        },
        {
          label: "预售",
          value: "preSold",
          isSelected: false,
        },
        {
          label: "待开盘",
          value: "unSold",
          isSelected: false,
        },
        {
          label: "在售",
          value: "selling",
          isSelected: false,
        },
        {
          label: "售罄",
          value: "sold",
          isSelected: false,
        },
      ],
      fields: [],
    };
  },
  mounted() {
    this.permissions = this.$store.getters.permissions;
    console.log(this.permissions, "this.permissions");
  },
  methods: {
    LookPhone() {
      if (this.permissions["Customer.LookPhoneNumber"]) {
        this.isShowPhone = !this.isShowPhone;
      } else {
        this.$message.warning({
          message: `您暂无查看客户电话权限`,
          showClose: true,
        });
      }
    },
    // 联系人弹窗关闭
    contractClose() {
      this.$refs.contractForm.resetFields();
      this.isShowContract = false;
    },
    //提交联系人
    submitContract() {
      this.$refs["contractForm"].validate((valid) => {
        if (valid) {
          let data = deepCopy(this.contractForm);
          if (this.contractTitle == "新增联系人") {
            this.reservationInfo.contracts.push(data);
          } else if (this.contractTitle == "编辑联系人") {
            this.reservationInfo.contracts.splice(this.contractIndex, 1, data);
          }
          this.isShowContract = false;
        } else {
          return false;
        }
      });
    },
    // 添加联系人
    addContract() {
      this.contractForm = {
        name: "",
        gender: "男",
        phoneNumber: "",
      };
      this.contractTitle = "新增联系人";
      this.isShowContract = true;
    },
    // 删除联系人
    delContract(index) {
      this.$confirm("此操作将删除该联系人, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.reservationInfo.contracts.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            showClose: true,
          });
        });
    },
    // 编辑联系人
    editContract(index) {
      this.contractIndex = index;
      this.contractTitle = "编辑联系人";
      this.isShowContract = true;
    },
    // 时间选择回调
    deteChange(value, name) {
      this.reservationInfo[name] = dateFormat(value);
    },
    // 上传自定义附件类型
    uploadFileType(type) {
      this.customFileType = type;
    },
    // 删除自定义附件
    delCustomFileItem(index) {
      let type = this.customFileType;
      this.reservationInfo[type].splice(index, 1);
      if (!this.reservationInfo[type].length) {
        this.reservationInfo[type] = [];
      }
      if (this.reservationInfo[type].length == 1) {
        this.$refs[type][0].doClose();
      }
    },
    // 上传附件钩子
    uploadFileChange(file) {
      let fileExt = file.name.split(".");
      fileExt = fileExt[fileExt.length - 1];
      let fileType = "";
      if (["jpg", "png", "jpeg"].indexOf(fileExt.toLowerCase()) > -1) {
        fileType = "image";
      }
      this.reservationInfo[this.customFileType].push({
        name: file.name,
        file: file.raw,
        url: URL.createObjectURL(file.raw),
        fileType,
      });
    },
    // 获取报备规则自定义字段
    getReservationRule(id) {
      getReservationRule(id).then((res) => {
        this.reservationRule = res.result;
        this.fields = res.result.fields;
        let data = {
          estateId: id,
          estateName: this.estateInfo.name,
          visitPersonNumber: "",
          visitTime: "",
          more: "",
          customerId: "",
          customerName: "",
          customerPhoneNumber: "",
          organizationUnitId: this.$store.getters.user.organizationUnitId,
          contracts: [],
          estateReservationRuleId: this.reservationRule.id,
        };
        this.fields.map((el) => {
          if (el.isRequired) {
            let name = el.name;
            let type, value;
            if (el.fieldType == "文本输入" || el.fieldType == "数字输入") {
              type = "blur";
              value = "输入";
            } else if (el.fieldType == "上传附件") {
              type = "change";
              value = "上传";
            } else {
              type = "change";
              value = "选择";
            }
            this.reservationRules[el.name] = [
              { required: true, trigger: type, message: `请${value}${name}` },
            ];
          }
          if (el.fieldType == "下拉多选" || el.fieldType == "上传附件") {
            data[el.name] = [];
          } else {
            data[el.name] = "";
          }
        });
        this.reservationInfo = deepCopy(data);
      });
    },
    //提交报备
    submitReservation() {
      this.$refs["reservationInfo"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let obj = deepCopy(this.reservationInfo);
          let form = this.reservationInfo;
          let field = deepCopy(this.fields);
          field.map((el) => {
            el.savedContent = form[el.name];
          });
          let files = [];
          field.map((el) => {
            if (el.fieldType == "上传附件" && el.savedContent.length) {
              files.push(el);
            }
          });
          let fields = deepCopy(field);
          fields.map((el) => {
            if (el.fieldType != "上传附件") {
              if (Array.isArray(el.savedContent)) {
                el.savedContent = el.savedContent.join("；");
              }
            } else {
              el.savedContent = "";
            }
          });
          let data = {
            customerId: obj.customerId,
            customerName: obj.customerName,
            customerPhoneNumber: obj.customerPhoneNumber,
            organizationUnitId: obj.organizationUnitId,
            estateId: obj.estateId,
            estateReservationRuleId: obj.estateReservationRuleId,
            estateName: obj.estateName,
            visitPersonNumber: obj.visitPersonNumber,
            visitTime: obj.visitTime,
            more: obj.more,
            contracts: obj.contracts,
            fields,
          };
          // 获取上传附件之前的附件数组
          let arr = [];
          files.map((el) => {
            el.savedContent.map((item) => {
              arr.push(item);
            });
          });
          if (files.length) {
            let list = [];
            files.map((el, index) => {
              let formData = new FormData();
              el.savedContent.map((item, i) => {
                formData.append(`files[${i}]`, item.file);
              });
              uploadMaterials(formData).then((res) => {
                res.result.items.map((e) => {
                  list.push(e);
                });
                el.savedContent = JSON.stringify(res.result.items);
                if (arr.length == list.length) {
                  if (this.unfinished) {
                    // 完成循环
                    this.unfinished = false;
                    data.fields.map((ele, i) => {
                      files.map((elem) => {
                        if (ele.name == elem.name) {
                          ele.savedContent = elem.savedContent;
                        }
                      });
                    });
                    // console.log(data,data);
                    this.createReservations(data);
                  }
                }
              });
            });
          } else {
            // console.log(data, "data");
            this.createReservations(data);
          }
        } else {
          return false;
        }
      });
    },
    createReservations(data) {
      createReservations(data)
        .then((res) => {
          this.loading = false;
          if (res) {
            this.$message.success({ message: res.message });
          }
          this.toReservations();
        })
        .catch((err) => {
          this.loading = false;
          this.$message({ message: err.error.message });
        });
    },
    toReservations() {
      this.$router.push({ path: "/reservation/index" });
    },
    // 多选框回调
    handleEstatesChange(selection) {
      this.checkedEstate = selection[0];
      this.estatesLock = selection.length > 0 ? false : true;
      if (selection.length > 1) {
        this.$refs.tb.clearSelection();
        this.$refs.tb.toggleRowSelection(selection.pop());
      }
    },
    submitEstates() {
      getPublicCounselors(this.checkedEstate.id).then((res) => {
        let counselors = [];
        counselors = res.result.managers;
        if (counselors.length) {
          this.estateInfo = this.checkedEstate;
          this.reservationInfo.estateName = this.estateInfo.name;
          this.reservationInfo.estateId = this.estateInfo.id;
          this.getReservationRule(this.estateInfo.id);
          this.isShowEstate = false;
        } else {
          this.$message.warning({
            message: `该楼盘暂无项目负责人员，请联系后台管理人员添加`,
            showClose: true,
          });
        }
      });
    },
    estateClose() {
      this.isShowEstate = false;
    },
    showEstate() {
      this.getPublicEstates();
      this.isShowEstate = true;
    },
    //获取楼盘
    getPublicEstates() {
      let query = {
        maxResultCount: this.query.maxResultCount,
        IsPutWeb:true,
        IsPutChannel:true,
      };
      if (this.searchValue) {
        query.filter = this.searchValue;
        query.intention = this.searchKey;
      }
      if (this.query.saleStatus) {
        query.saleStatus = this.query.saleStatus;
      }
      this.isLoading = true;
      getPublicEstates(query).then((res) => {
        this.estates = res.result.items;
        this.isLoading = false;
      });
    },
    // 多选框回调
    handleCustomersChange(selection) {
      this.checkedCustomer = selection;
      this.userLock = this.checkedCustomer.length > 0 ? false : true;
      if (selection.length > 1) {
        this.$refs.tbCustomer.clearSelection();
        this.$refs.tbCustomer.toggleRowSelection(selection.pop());
      }
    },
    submitCustomers() {
      this.customerInfo = [];
      this.checkedCustomer.map((item) => {
        this.reservationInfo.customerId = item.id;
        this.reservationInfo.customerName = item.name;
        this.reservationInfo.customerPhoneNumber = item.phoneNumber;
      });
      this.isShowCustomer = false;
      if (this.permissions["Customer.LookPhoneNumber"]) {
        getCustomerPhone(this.reservationInfo.customerId).then((res) => {
          this.customerPhoneNumber = res.result;
        });
      }
    },
    customerClose() {
      this.isShowCustomer = false;
    },
    showCustomers() {
      this.getCustomers();
      this.isShowCustomer = true;
    },
    //获取客源
    getCustomers() {
      let query = {
        maxResultCount: this.query.maxResultCount,
      };
      if (this.searchUserValue) {
        query.filter = this.searchUserValue;
        query.condition = this.searchUserKey;
      }
      this.isLoading = true;
      getCustomers(query).then((res) => {
        this.customers = res.result.items;
        this.isLoading = false;
      });
    },
    // 搜索前置条件
    filterUserSelect(val) {
      console.log(val, 1111);
      switch (val) {
        case "name":
          this.searchUserText = "请输入用户名称";
          break;
        case "phoneNumber":
          this.searchUserText = "请输入用户电话";
          break;
        case "":
          this.searchUserText = "请输入客户名称/电话";
          break;
      }
      this.searchUserKey = val;
    },
    filterSelect(val) {
      switch (val) {
        case "name":
          this.searchText = "请输入楼盘名称";
          break;
        case "realAddress":
          this.searchText = "请输入楼盘地址";
          break;
        case "userName":
          this.searchText = "请输入项目负责人";
          break;
      }
      this.searchKey = val;
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#createReservation {
  min-width: 1180px;
  .main {
    margin: 20px;
    min-height: calc(100vh - 250px);
    border-radius: $--border-radius-base;
    background: #fff;
    .main-title {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      color: #888;
      font-size: 16px;
    }
    .reservation-info {
      padding: 20px;
      ::v-deep .el-date-editor {
        .el-input__inner {
          padding-left: 30px;
        }
        .el-icon-circle-close {
          right: 0;
        }
      }
      .get-customer {
        @include flex(column, flex-start);
      }
      .customer-input {
        width: 330px;
      }
      .estate-info {
        @include flex(row, center);
        justify-content: space-between;
        padding: 20px;
        background: #f7f7f7;
        .estate-main {
          @include flex(row, center);
          .estate-cover {
            margin-right: 30px;
            width: 160px;
            height: 116px;
          }
          .edtate-detail {
            @include flex(column, flex-start);
            justify-content: space-between;
            height: 116px;
            .name,
            .address {
              color: #444;
              .status {
                margin-left: 30px;
                // display: inline-block;
                padding: 2px 5px;
                border-radius: $--border-radius-base;
                font-size: 12px;
                color: #fff;
                background: $--color-primary;
              }
            }
            .info {
              color: #888;
            }
          }
        }
        .estate-price {
          font-size: 26px;
          color: $--color-primary;
        }
      }
      .customers-info {
        @include flex(row, center);
        margin-bottom: 10px;
        .el-input {
          width: 220px;
        }
        .phone {
          margin-left: 20px;
          color: #717171;
        }
      }
      .customers-info:last-child {
        margin-bottom: 0;
      }

      .customer-phone {
        display: inline-block;
        width: 100px;
      }

      .show-svg {
        cursor: pointer;
        position: relative;
        bottom: 1px;
      }

      .el-select,
      .el-input {
        width: 330px;
      }

      .form-flex {
        flex-wrap: wrap;

        .custom-form {
          width: 50%;
          .el-select,
          .el-input {
            width: 330px;
          }

          .error-tip {
            color: #f56c6c;
            position: relative;
            top: -5px;
          }

          .upload-btn {
            margin-right: 10px;
          }

          .el-image {
            margin-right: 10px;
            width: 30px;
            height: 30px;
          }

          .file-box {
            .file-item {
              margin-bottom: 0;

              span {
                max-width: 170px !important;
              }
            }

            i {
              cursor: pointer;
            }
          }
        }
      }

      .add-contract {
        text-align: center;
      }
    }
  }
  .btn {
    margin: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    background: #fff;
    text-align: center;
  }
  .dialog-estate {
    .estate-main {
      width: 1080px;
      .filter-heade {
        margin-bottom: 20px;
        .input-with-select {
          width: 630px;
          .el-select {
            width: 150px;
          }
        }
        .filter-btn {
          margin-top: 20px;
          .filter-tit {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .el-dialog {
    .el-table {
      ::v-deep .el-table__header-wrapper {
        .el-table__header {
          .has-gutter {
            .el-checkbox {
              display: none;
            }
          }
        }
      }
    }
  }
}

.file-item {
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #000;

  &:last-child {
    margin-bottom: 0;
  }

  .el-image,
  img {
    margin-right: 10px;
    width: 30px;
    height: 30px;
  }

  span {
    display: inline-block;
    max-width: 260px;
    white-space: nowrap; /*内容超宽后禁止换行显示*/
    overflow: hidden; /*超出部分隐藏*/
    text-overflow: ellipsis; /*文字超出部分以省略号显示*/
  }

  i {
    margin-left: 5px;
    cursor: pointer;
  }

  &.pop-file {
    width: 340px;
  }

  .down-btn {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
